import { useEffect, useState, useCallback } from "react";

const KEY = "bharatstack:upvoted";

const load = () => {
    try {
        return new Set(JSON.parse(localStorage.getItem(KEY) || "[]"));
    } catch {
        return new Set();
    }
};

const save = (set) => {
    try {
        localStorage.setItem(KEY, JSON.stringify(Array.from(set)));
    } catch {
        /* ignore */
    }
};

export function useUpvotes() {
    const [voted, setVoted] = useState(load);

    const has = useCallback((slug) => voted.has(slug), [voted]);

    const add = useCallback((slug) => {
        setVoted((prev) => {
            if (prev.has(slug)) return prev;
            const next = new Set(prev);
            next.add(slug);
            save(next);
            return next;
        });
    }, []);

    return { has, add };
}

export function getLocalCount(slug) {
    try {
        const raw = localStorage.getItem(`bharatstack:count:${slug}`);
        return raw ? parseInt(raw, 10) : 0;
    } catch {
        return 0;
    }
}

export function bumpLocalCount(slug, base = 0) {
    try {
        const next = base + 1;
        localStorage.setItem(`bharatstack:count:${slug}`, String(next));
        return next;
    } catch {
        return base + 1;
    }
}

export function useDismissibleBanner(id) {
    const storageKey = `bharatstack:banner:${id}`;
    const [open, setOpen] = useState(true);

    useEffect(() => {
        try {
            if (localStorage.getItem(storageKey) === "1") setOpen(false);
        } catch {
            /* ignore */
        }
    }, [storageKey]);

    const dismiss = useCallback(() => {
        try {
            localStorage.setItem(storageKey, "1");
        } catch {
            /* ignore */
        }
        setOpen(false);
    }, [storageKey]);

    return { open, dismiss };
}
